export default __webpack_public_path__ + "static/media/c1.6c461deb.jpg";